import { SelectOption, makeIsAllowed } from '@kanda-libs/ks-component-ts';

export const EMPLOYED_PROPS = {
  mainOccupation: {
    placeholder: 'Your main occupation',
  },
  employerName: {
    placeholder: "Your employer's name",
  },
  yearsEmployed: {
    label: 'Years employed',
    placeholder: 'Your years employed',
    isAllowed: makeIsAllowed(0, 100),
  },
  monthsEmployed: {
    label: 'Months employed',
    placeholder: 'Your months employed',
    isAllowed: makeIsAllowed(0, 100),
  },
  employedType: {
    label: 'Employment type',
    placeholder: 'Select...',
    name: 'credit.employment_details.employed_details.employed_type',
  },
  monthlyIncome: {
    type: 'price',
    placeholder: '£0.00',
    icon: 'pound',
    iconVariant: 'dark',
    label: 'Monthly Income After Tax',
    symbol: '',
    name: 'credit.employment_details.employed_details.monthly_income_after_tax',
  },
};

export const EMPLOYMENT_TYPE_VALIDATION = {
  required: { value: true, message: 'Employment type is required.' },
};

export const EMPLOYMENT_TYPE_OPTIONS: SelectOption[] = [
  { name: 'Full Time', value: 'full_time' },
  { name: 'Part Time', value: 'part_time' },
];
